import * as t from 'io-ts';

export const ImportedPlanSchema = t.exact(t.interface({
    numOfPlannedAnimals: t.number,
    skippedBreedingIds: t.array(t.string),
}));

export interface ImportedPlan extends t.TypeOf<typeof ImportedPlanSchema> {}
